import { css } from 'styled-components';

const heading = css`
  color: #35353b;
  font-size: 1.5rem;
  font-weight: 500;
  letter-spacing: -1.2px;
  text-align: center;
  ${({ theme }) => css`
    ${theme.breakpoints.up('sm')} {
      font-size: 2rem;
      line-height: 1.25;
      letter-spacing: -1.6px;
    }
    ${theme.breakpoints.up('md')} {
      font-size: 2.5rem;
      line-height: 1.5;
      letter-spacing: -2px;
    }
  `}
`;

export default heading;
